import Vue from 'vue'
import store from '@/store'

/**
 * Action 权限指令
 * 指令用法：
 *  - 在需要控制 action 级别权限的组件上使用 v-action:[method] , 如下：
 *    <i-button v-action:add >添加用户</a-button>
 *    <a-button v-action:delete>删除用户</a-button>
 *    <a v-action:edit @click="edit(record)">修改</a>
 */
Vue.directive('action', {
  inserted: function(el, binding, vnode) {
    const actionCode = binding.arg
    const actions = vnode.context.$route.meta.actions || []
    let matched = false
    for (let i = 0; i < actions.length; i++) {
      // 只会替换匹配的文本内容，如果不是简单的文本内容。
      // 如：<div><a>新</a><a>增</a></div> 则不会替换。
      if (actions[i].code === actionCode) {
        const text = el.textContent
        el.innerHTML = el.innerHTML.replace(text, actions[i].name)
        matched = true
      }
    }
    if (store.getters.isSAdmin) {
      return
    }
    if (!matched) {
      ;(el.parentNode && el.parentNode.removeChild(el)) || (el.style.display = 'none')
    }
  }
})
